import { Pipe, PipeTransform } from '@angular/core';
import { ITranscriptionState } from '../../../store/reducers/transcription.reducer';
import { EHttpErrorStatus } from '../../../core/configurations/errors';

@Pipe({
  name: 'hasTranscription',
  standalone: true,
})
export class HasTranscriptionPipe implements PipeTransform {
  transform({ aceTranscription, standardTranscription }: ITranscriptionState): boolean {
    return (
      aceTranscription.errorResponse?.status !== EHttpErrorStatus.notFound ||
      standardTranscription.errorResponse?.status !== EHttpErrorStatus.notFound
    );
  }
}
